<template>
  <DynamicFormList :active.sync="active" :items="itemsLocalMapped" form-on-top>
    <template #items="{ item }">
      <DynamicFormListItem #default="{ active, toggle }">
        <SchoolRecommendationForm
          :has-items="hasItems"
          :item="item"
          :active="active"
          :readonly="readonly"
          :academic-year-id="academicYearId"
          :region="region"
          :select-region="selectRegion"
          :exclude-region="excludeRegion"
          :municipality="municipality"
          :select-municipality="selectMunicipality"
          :exclude-municipality="excludeMunicipality"
          :schools-added="schoolsAdded"
          :tap-request-id="tapRequestId"
          editting
          @submit="edit"
          @edit="toggle"
          @remove="remove(item)"
          @cancel="toggle"
        />
      </DynamicFormListItem>
    </template>

    <template #form="{ toggle }">
      <SchoolRecommendationForm
        :has-items="hasItems"
        :academic-year-id="academicYearId"
        :region="region"
        :select-region="selectRegion"
        :exclude-region="excludeRegion"
        :municipality="municipality"
        :select-municipality="selectMunicipality"
        :exclude-municipality="excludeMunicipality"
        :schools-added="schoolsAdded"
        :tap-request-id="tapRequestId"
        @submit="add"
        @cancel="toggle"
      />
    </template>

    <template v-if="!readonly" #form-toggler="{ toggle }">
      <div class="text-right pr-3">
        <ActionButton
          text="Añadir"
          variant="success"
          i="fas fa-file-plus"
          @click="toggle"
        />
      </div>
    </template>
  </DynamicFormList>
</template>

<script>
import { DynamicFormList, DynamicFormListItem } from '@/components/common';
import ActionButton from 'ActionButton';
import alert from '@/mixin/alert.mixin';
import SchoolRecommendationForm from './_components/SchoolRecommendationForm';
import { schoolRecommendationApi } from './_api';
import { schoolRecommendationReturnDtoToModel } from './_utils';

export default {
  name: 'Recommendation',
  mixins: [alert],
  components: {
    DynamicFormList,
    DynamicFormListItem,
    ActionButton,
    SchoolRecommendationForm,
  },
  props: {
    academicYearId: { type: [Number, String], required: true, default: null },
    tapRequestId: { type: [Number, String], required: true, default: null },
    tapRequestTypeId: { type: [Number, String], required: true, default: null },
    region: { type: Object, default: null },
    selectRegion: { type: Boolean, default: false },
    excludeRegion: { type: Boolean, default: false },
    municipality: { type: Object, default: null },
    selectMunicipality: { type: Boolean, default: false },
    excludeMunicipality: { type: Boolean, default: false },
    /* SchoolRecommendationDto[] */
    items: { type: Array, required: true, default: () => [] },
    readonly: { type: Boolean, default: false },
  },
  data: () => ({ active: false, itemsLocal: [] }),
  computed: {
    items_sync: {
      get() {
        return this.items;
      },
    },
    hasItems() {
      return this.itemsLocal.length > 0;
    },
    itemsLocalMapped() {
      return this.itemsLocal.map(schoolRecommendationReturnDtoToModel);
    },
    schoolsAdded() {
      return this.itemsLocalMapped.map((x) => x.school);
    },
  },
  methods: {
    async add(item, reset) {
      if (this.readonly) {
        return;
      }
      const result = await schoolRecommendationApi.create({
        tapRequestId: this.tapRequestId,
        tapRequestTypeId: this.tapRequestTypeId,
        model: item,
      });
      if (result) {
        this.items_sync.push(result);
        this.itemsLocal.push(result);
        reset(true);
      }
    },
    async edit(item, reset) {
      if (this.readonly) {
        return;
      }
      const result = await schoolRecommendationApi.edit({
        id: item.id,
        tapRequestId: this.tapRequestId,
        tapRequestTypeId: this.tapRequestTypeId,
        model: item,
      });
      if (result) {
        const index = this.items_sync.findIndex((x) => x.id === result.id);
        this.items_sync.splice(index, 1, result);
        this.itemsLocal.splice(index, 1, result);
        reset();
      }
    },
    async remove(item) {
      if (this.readonly) {
        return;
      }
      const confirm = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea eliminar la escuela ${item.school.name} con las alternativas de ubicación?`
      );
      if (!confirm) return;
      const result = await schoolRecommendationApi.remove({
        id: item.id,
        tapRequestTypeId: this.tapRequestTypeId,
      });
      if (result) {
        const index = this.items_sync.findIndex((x) => x.id === item.id);
        this.items_sync.splice(index, 1);
        this.itemsLocal.splice(index, 1);

        this.ShowToast(
          'Proceso exitoso.',
          'La escuela con su(s) alternativa(s) de ubicación han sido eliminada(s) exitosamente.',
          'success'
        );
      }
    },
  },
  watch: {
    itemsLocal: {
      handler(value) {
        if (!this.readonly && !this.active && !value.length) {
          this.active = true;
        }
      },
      deep: true,
    },
    items_sync: {
      handler(value) {
        this.$emit('update:items', value);
        this.$emit('input', value.length);
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.itemsLocal = [...this.items];
  },
};
</script>
